import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from 'src/app/shared/GenericService';
import { SondaggioRispostaDTO } from 'src/app/shared/dto/sondaggi/sondaggioRisposta';
import { environment } from 'src/environments/environment';
import { CollaboratoreDTO } from '../../shared/dto/domain/collaboratore';
import { ResponseQueryByCriteria } from '../../shared/dto/responseQueryByCriteria';


@Injectable({
  providedIn: 'root'
})
export class SondaggioRispostaService extends GenericService<SondaggioRispostaDTO, number> {

  constructor(http: HttpClient) {
    super(http);
    this.url = environment.urlPrefix + '/services/rest/json/risposta-sondaggio';
  }

  public sondaggioRispostaListByList(pageNumber?: number, pageSize?: number, direction?: string, sortField?: string,
    titolo?: string,
    collaboratore?: CollaboratoreDTO,
    dataScadenza?: Date
  ): Observable<ResponseQueryByCriteria<SondaggioRispostaDTO>> {
    let params = {};
    if (pageNumber != null) params["pageNumber"] = String(pageNumber);
    if (pageSize != null) params["pageSize"] = String(pageSize);
    if (direction != null) params["direction"] = direction;
    if (sortField != null) params["sortField"] = sortField;

    if (titolo != null) params["titolo"] = titolo;
    if (collaboratore != null) params["collaboratore"] = collaboratore.id;
    if (dataScadenza != null) params["dataScadenza"] = dataScadenza.toISOString();
    return this.http.get<ResponseQueryByCriteria<SondaggioRispostaDTO>>(`${this.url}/sondaggioRispostaListByList`, {
      params: params
    });
  }

  readRisposteSondaggioCollaboratore(collaboratoreId: number, sondaggioId: number){
    return this.http.get<SondaggioRispostaDTO>(`${this.url}/${sondaggioId}/collaboratore/${collaboratoreId}`);
  }

  readRisposteSondaggio(sondaggioId: number){
    return this.http.get<SondaggioRispostaDTO>(`${this.url}/${sondaggioId}`);
  }
}
